(function () {
    var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
    // Showroom runs on AEST — compute "now" in Sydney, not the visitor's timezone.
    function sydneyParts() {
      try {
        var o = {};
        new Intl.DateTimeFormat('en-CA', { timeZone: 'Australia/Sydney', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
        return { y: +o.year, m: +o.month, d: +o.day, min: (+o.hour) * 60 + (+o.minute) };
      } catch (e) { var n = new Date(); return { y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate(), min: n.getHours() * 60 + n.getMinutes() }; }
    }
    function sydneyToday() { var p = sydneyParts(); return new Date(p.y, p.m - 1, p.d); }
    function parseList(s) {
      return (s || '').split(',').map(function (x) { return x.trim(); }).filter(function (x) { return x.length; });
    }

    document.querySelectorAll('[data-booksch]').forEach(function (root) {
      var typeIn = root.querySelector('[data-bk-type]');
      var slotIn = root.querySelector('[data-bk-slot]');
      var dayIn = root.querySelector('[data-bk-day]');
      var timeIn = root.querySelector('[data-bk-time]');
      var sumType = root.querySelector('[data-bk-sum-type]');
      var sumDay = root.querySelector('[data-bk-sum-day]');
      var sumTime = root.querySelector('[data-bk-sum-time]');
      var datesEl = root.querySelector('[data-bk-dates]');
      var slotsEl = root.querySelector('[data-bk-slots]');
      var timesWrap = root.querySelector('[data-bk-times-wrap]');

      // Tool handoff prefill: the room-mode calculator (and product CTAs) arrive with
      // ?src / ?room / ?seats / ?dist / ?subs / ?product. Turn them into a human sentence in
      // "Tell us about your space" — but only when the textarea is empty; a visitor's own
      // words are never overwritten.
      try {
        var q = new URLSearchParams(location.search);
        var ta = root.querySelector('textarea[name="contact[body]"]');
        if (q.get('demo') === '1') { var bt = root.querySelector('[data-bk-type]'); if (bt) bt.value = 'Showroom audition'; }
        /* ?plan=1 from /pages/my-system: the saved plan comes with the booking. */
        if (q.get('plan') === '1' && window.CHT && CHT.system && ta) { CHT.system.attach(ta.form || root.querySelector('form')); }
        if (ta && !ta.value.trim() && (q.get('room') || q.get('src') || q.get('product'))) {
          var bits = [];
          var src = (q.get('src') || '').toLowerCase().replace(/[^a-z0-9-_ ]/g, '').slice(0, 40);
          var srcName = src === 'room-mode' ? 'the room mode calculator' : (src ? 'the ' + src.replace(/[-_]+/g, ' ') + ' tool' : '');
          var room = (q.get('room') || '').trim().slice(0, 40);
          var rm = room.match(/^(\d{1,3}(?:\.\d{1,2})?)x(\d{1,3}(?:\.\d{1,2})?)x(\d{1,3}(?:\.\d{1,2})?)(m|ft)?$/i);
          if (rm) bits.push('my room is ' + rm[1] + ' × ' + rm[2] + ' × ' + rm[3] + ' ' + (rm[4] ? rm[4].toLowerCase() : 'm'));
          var seats = parseInt(q.get('seats'), 10);
          if (isFinite(seats) && seats >= 1 && seats <= 12) {
            var sTxt = seats + ' seat' + (seats > 1 ? 's' : '');
            var dist = parseFloat(q.get('dist'));
            if (isFinite(dist) && dist > 0 && dist <= 30) sTxt += ' at ' + dist + ' m';
            bits.push(sTxt);
          }
          var subs = parseInt(q.get('subs'), 10);
          if (isFinite(subs) && subs >= 1 && subs <= 8) bits.push('planning ' + subs + ' subwoofer' + (subs > 1 ? 's' : ''));
          var sentence = '';
          if (bits.length) sentence = (srcName ? 'From ' + srcName + ': ' : '') + bits.join(', ') + '.';
          var prod = (q.get('product') || '').replace(/[^a-z0-9-]/gi, '').slice(0, 80);
          var prodPhrase = '';
          if (prod) {
            var pn = prod.replace(/-+/g, ' ').trim();
            if (pn) {
              prodPhrase = (q.get('demo') === '1' ? 'I’d like to audition ' : 'I’m interested in ') + pn.charAt(0).toUpperCase() + pn.slice(1) + (q.get('demo') === '1' ? ' in the showroom.' : '.');
              sentence += (sentence ? ' ' : '') + prodPhrase;
            }
          }
          if (sentence) ta.value = sentence;

          /* The phrase above is title-cased from the handle, so it reads "Svs sb1000 pro sealed
             subwoofer" - the right product, spelled wrong, in a lead a salesperson has to read out.
             Resolve the real title from the product JSON and swap it in, and put it in its own
             field so the lead does not depend on anyone parsing the sentence. The handle-derived
             text stands until the fetch lands, so a slow or failed request still leaves something
             useful, and the swap is skipped if the visitor has touched the box since. Only the
             title from the response is written - nothing from the query string is printed back.
             Matches the prefill on the quote form in sections/lead-form.liquid. */
          if (prodPhrase && /^[a-z0-9-]{1,255}$/i.test(prod)) {
            (function (placeholderText, wroteAtLoad) {
              fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'products/' + encodeURIComponent(prod) + '.js', { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function (pj) {
                  if (!pj || !pj.title) return;
                  var hid = root.querySelector('[data-bk-product]');
                  if (hid && !hid.value) hid.value = pj.title;
                  if (ta.value === wroteAtLoad) {
                    ta.value = wroteAtLoad.replace(placeholderText, q.get('demo') === '1' ? ('I’d like to audition the ' + pj.title + ' in the showroom.') : ('I’m interested in ' + pj.title + '.'));
                  }
                })
                .catch(function () {});
            })(prodPhrase, ta.value);
          }
        }
      } catch (e) {}

      // Meeting type chips. "Showroom audition" (l13) is a different promise from a consult: it
      // reveals the demo rooms and swaps the copy from "we design a plan" to "we confirm the room
      // and the gear are free for your preferred time".
      var typeChips = root.querySelector('[data-bk-typechips]');
      var aud = root.querySelector('[data-bk-aud]');
      var roomIn = root.querySelector('[data-bk-room]');
      var gearIn = root.querySelector('[data-bk-gear]');
      function swapCopy(mode) {
        root.querySelectorAll('[data-consult][data-audition]').forEach(function (el) {
          var v = el.getAttribute(mode === 'audition' ? 'data-audition' : 'data-consult');
          if (el.tagName === 'TEXTAREA') el.placeholder = v; else el.textContent = v;
        });
      }
      function setType(v) {
        if (typeChips) typeChips.querySelectorAll('.booksch__chip').forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-bk-typeval') === v); });
        if (typeIn) typeIn.value = v;
        if (sumType) sumType.textContent = v === 'Showroom audition' ? 'Showroom audition' : v;
        var isAud = v === 'Showroom audition';
        if (aud) aud.hidden = !isAud;
        swapCopy(isAud ? 'audition' : 'consult');
        var rr = root.querySelector('[data-bk-sum-room-row]'), gr = root.querySelector('[data-bk-sum-gear-row]');
        if (rr) rr.hidden = !isAud || !(roomIn && roomIn.value);
        if (gr) gr.hidden = !isAud || !(gearIn && gearIn.value);
      }
      if (typeChips) {
        typeChips.addEventListener('click', function (e) {
          var b = e.target.closest('[data-bk-typeval]'); if (!b) return;
          setType(b.getAttribute('data-bk-typeval'));
        });
      }
      if (aud) {
        var rooms = Array.prototype.slice.call(aud.querySelectorAll('[data-bk-roomcard]'));
        function pickRoom(roomEl) {
          rooms.forEach(function (r) {
            var on = r === roomEl; r.classList.toggle('is-on', on);
            var b = r.querySelector('[data-bk-room-btn]'); if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
            if (!on) r.querySelectorAll('[data-bk-gear-chip]').forEach(function (g) { g.setAttribute('aria-pressed', 'false'); });
          });
          if (roomIn) roomIn.value = roomEl ? roomEl.getAttribute('data-bk-roomval') : '';
          var sr = root.querySelector('[data-bk-sum-room]'), rr = root.querySelector('[data-bk-sum-room-row]');
          if (sr) sr.textContent = roomIn && roomIn.value ? roomIn.value : '–';
          if (rr) rr.hidden = !(roomIn && roomIn.value);
          syncGear();
        }
        function syncGear() {
          var on = Array.prototype.slice.call(aud.querySelectorAll('[data-bk-gear-chip][aria-pressed="true"]')).map(function (g) { return g.getAttribute('data-bk-gearval'); });
          if (gearIn) gearIn.value = on.join(', ').slice(0, 500);
          var sg = root.querySelector('[data-bk-sum-gear]'), gr = root.querySelector('[data-bk-sum-gear-row]');
          if (sg) sg.textContent = on.length ? on.join(', ') : '–';
          if (gr) gr.hidden = !on.length;
        }
        aud.addEventListener('click', function (e) {
          var g = e.target.closest('[data-bk-gear-chip]');
          if (g) {
            var r = g.closest('[data-bk-roomcard]');
            if (r && !r.classList.contains('is-on')) pickRoom(r);
            g.setAttribute('aria-pressed', g.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
            syncGear(); return;
          }
          var rb = e.target.closest('[data-bk-room-btn]');
          if (rb) { var re = rb.closest('[data-bk-roomcard]'); pickRoom(re.classList.contains('is-on') ? null : re); }
        });
        // ?demo=1 (PDP "on demo" link, audition CTAs) opens straight onto the audition path.
        try { if (new URLSearchParams(location.search).get('demo') === '1') setType('Showroom audition'); } catch (e) {}
      }

      if (!datesEl || !slotsEl) return;

      // Require a date + time before the enquiry can be submitted.
      var formEl = root.querySelector('form.booksch__form') || root.querySelector('form');
      if (formEl) {
        formEl.addEventListener('submit', function (e) {
          if (!slotIn || !slotIn.value) {
            e.preventDefault();
            var err = root.querySelector('[data-bk-error]');
            if (!err) { err = document.createElement('p'); err.setAttribute('data-bk-error', ''); err.setAttribute('role', 'alert'); err.className = 'booksch__empty'; err.style.color = 'var(--c-danger-text,#b3261e)'; datesEl.parentNode.insertBefore(err, datesEl); }
            err.textContent = 'Please choose a date and time above.';
            if (datesEl.scrollIntoView) { datesEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          }
        });
      }

      // Config from data-* attributes.
      var daysAhead = parseInt(root.getAttribute('data-bk-days-ahead'), 10);
      if (isNaN(daysAhead) || daysAhead < 1) daysAhead = 21;
      var openDays = parseList(root.getAttribute('data-bk-open-days'));
      if (!openDays.length) openDays = ['Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var openIdx = {};
      openDays.forEach(function (n) {
        var i = DOW.indexOf(n.slice(0, 3));
        if (i >= 0) openIdx[i] = true;
      });
      var closedDates = {};
      parseList(root.getAttribute('data-bk-closed-dates')).forEach(function (d) { closedDates[d] = true; });
      var timeSlots = parseList(root.getAttribute('data-bk-time-slots'));
      if (!timeSlots.length) timeSlots = ['10:00 AM', '1:00 PM', '4:00 PM'];

      var selectedDate = null; // { iso, label } of chosen date button

      function labelFor(d) {
        return DOW[d.getDay()] + ' ' + d.getDate() + ' ' + MON[d.getMonth()];
      }

      function updateSlot() {
        var timeVal = slotIn && slotIn.getAttribute('data-time') || '';
        if (selectedDate && timeVal) {
          var combined = selectedDate.label + ', ' + timeVal;
          if (slotIn) slotIn.value = combined;
        } else if (slotIn) {
          slotIn.value = '';
        }
        if (dayIn) dayIn.value = selectedDate ? selectedDate.label : '';
        if (timeIn) timeIn.value = timeVal;
        if (sumDay) sumDay.textContent = selectedDate ? selectedDate.label : '–';
        if (sumTime) sumTime.textContent = timeVal || '–';
      }

      function parseTimeToMin(t) {
        var m = String(t).match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);
        if (!m) return null;
        var h = parseInt(m[1], 10), mn = parseInt(m[2], 10), ap = (m[3] || '').toUpperCase();
        if (ap === 'PM' && h < 12) h += 12;
        if (ap === 'AM' && h === 12) h = 0;
        return h * 60 + mn;
      }
      function buildSlots() {
        slotsEl.innerHTML = '';
        if (slotIn) { slotIn.removeAttribute('data-time'); }
        var isToday = selectedDate && selectedDate.iso === iso(sydneyToday());
        var nowMin = 0;
        if (isToday) { nowMin = sydneyParts().min; }
        var shown = 0;
        timeSlots.forEach(function (t) {
          if (isToday) { var tm = parseTimeToMin(t); if (tm != null && tm <= nowMin) return; } // drop times already past today
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'booksch__slot';
          b.setAttribute('data-bk-slotval', t);
          b.setAttribute('aria-pressed', 'false');
          b.textContent = t;
          b.addEventListener('click', function () {
            slotsEl.querySelectorAll('.booksch__slot').forEach(function (s) {
              s.setAttribute('aria-pressed', s === b ? 'true' : 'false');
            });
            if (slotIn) slotIn.setAttribute('data-time', t);
            updateSlot();
          });
          slotsEl.appendChild(b);
          shown++;
        });
        if (!shown) { slotsEl.innerHTML = '<p class="booksch__empty">No more times available today. Please choose another day.</p>'; }
      }
      // Roving keyboard support for time slots (mirrors the date scroller).
      slotsEl.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var btns = Array.prototype.slice.call(slotsEl.querySelectorAll('.booksch__slot'));
        var i = btns.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        var n = e.key === 'ArrowRight' ? Math.min(btns.length - 1, i + 1) : Math.max(0, i - 1);
        if (btns[n]) btns[n].focus();
      });

      function selectDate(btn, dateObj) {
        datesEl.querySelectorAll('.booksch__date').forEach(function (d) {
          d.setAttribute('aria-pressed', d === btn ? 'true' : 'false');
        });
        selectedDate = dateObj;
        if (timesWrap) timesWrap.hidden = false;
        buildSlots();
        updateSlot();
      }

      // Build the horizontal date picker.
      var today = sydneyToday();
      today.setHours(0, 0, 0, 0);
      var count = 0;
      for (var offset = 0; offset < daysAhead; offset++) {
        var d = new Date(today.getTime());
        d.setDate(today.getDate() + offset);
        var key = iso(d);
        if (!openIdx[d.getDay()]) continue;
        if (closedDates[key]) continue;
        (function (dd, kk) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'booksch__date';
          b.setAttribute('data-bk-dateval', kk);
          b.setAttribute('aria-pressed', 'false');
          var lbl = labelFor(dd);
          b.setAttribute('aria-label', lbl);
          b.innerHTML =
            '<span class="booksch__date-dow">' + DOW[dd.getDay()] + '</span>' +
            '<span class="booksch__date-num">' + dd.getDate() + '</span>' +
            '<span class="booksch__date-mon">' + MON[dd.getMonth()] + '</span>';
          b.addEventListener('click', function () { selectDate(b, { iso: kk, label: lbl }); });
          datesEl.appendChild(b);
        })(d, key);
        count++;
      }

      if (!count) {
        datesEl.innerHTML = '<p class="booksch__empty">No dates are open just now. Please call us and we’ll find a time.</p>';
      }

      // Roving keyboard support: arrow keys move between date buttons.
      datesEl.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var btns = Array.prototype.slice.call(datesEl.querySelectorAll('.booksch__date'));
        var i = btns.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        var next = e.key === 'ArrowRight' ? Math.min(i + 1, btns.length - 1) : Math.max(i - 1, 0);
        btns[next].focus();
      });

    });
  })();
